"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolarisNavLink = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
// This component needed to be created to configure Polaris Navigation to not reload the
// entire page when clicking on a menu navigation item.
const PolarisNavLink = (_a) => {
    var { children, url = '', external, 
    // We have to set null to this when it isn't received to pass the type check
    // The ref does get passed via 'rest' when needed
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref = null } = _a, rest = __rest(_a, ["children", "url", "external", "ref"]);
    // External links should use the regular HTML link tag
    const isOutboundLink = (link) => {
        const linkRegex = /^(?:[a-z][a-z\d+.-]*:|\/\/)/;
        return linkRegex.test(link);
    };
    if (external || isOutboundLink(url) || rest.download) {
        return (react_1.default.createElement("a", Object.assign({ href: url }, rest, { rel: 'noreferrer', target: '_blank' }), children));
    }
    return (react_1.default.createElement(react_router_dom_1.Link, Object.assign({ to: url }, rest), children));
};
exports.PolarisNavLink = PolarisNavLink;
